import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'

import { industryActions } from 'store/Industry'
import { all } from 'store/Industry/Industry.selector'
import { all as allOrders } from 'store/Order/Order.selector'

import { IndustryCertificateTable } from 'components/IndustryCertificate/IndustryCertificateList/IndustryCertificateTable'

import { Pagination } from 'components/Pagination'
import { GridHeader } from '../GridHeader'

import * as S from './styled'

export function CertificatesTable() {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { ordersKeys } = useSelector(allOrders)
  const { industriesWithCertificatesInOrders, loading } = useSelector(all)

  function onFilterPaginate(params = {}) {
    dispatch(
      industryActions.fetchAllWithCertificatesInOrders({ params, ordersKeys })
    )
  }

  useEffect(() => {
    dispatch(
      industryActions.fetchAllWithCertificatesInOrders({
        ordersKeys
      })
    )
  }, [dispatch, ordersKeys])

  return (
    <S.Wrapper container>
      <S.FullGrid item xs={12}>
        <GridHeader title={t('common:certificatesList')} />

        <S.GridTable>
          <IndustryCertificateTable
            isLoading={loading}
            rows={industriesWithCertificatesInOrders.items}
          />
          {industriesWithCertificatesInOrders.pagination?.totalItems > 0 && (
            <Pagination
              filters={{
                limit: industriesWithCertificatesInOrders.pagination.limit,
                page: industriesWithCertificatesInOrders.pagination.page
              }}
              limit={industriesWithCertificatesInOrders.pagination.limit}
              page={industriesWithCertificatesInOrders.pagination.page}
              totalItems={
                industriesWithCertificatesInOrders.pagination.totalItems
              }
              setFilter={onFilterPaginate}
            />
          )}
        </S.GridTable>
      </S.FullGrid>
    </S.Wrapper>
  )
}
